export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// ../~/d3-chord/index.js
// module id = +P6R
// module chunks = 0